.description__heading {
  margin-top: 20px;
  margin-bottom: 20px;
}

.description__content {
  font-size: 14px;
  line-height: 1.4285714286;
  color: #626469;
}

@media screen and (max-width: 979px) {
  .description__content {
    margin-bottom: 12px;
  }
}

@media screen and (min-width: 980px) {
  .description__content {
    line-height: 24px;
    width: 780px;
  }
}

.product-description-img-with-carousal {
  --se-carousel-item-width: 250px;
}

@media screen and (min-width: 720px) and (max-width: 980px) {
  .product-description-img-with-carousal {
    --se-carousel-item-width: 235px;
  }
}

@media screen and (max-width: 719px) {
  .product-description-img-with-carousal {
    --se-carousel-item-width: 310px;
  }
}

.product-description-img {
  --se-carousel-item-width: 260px;
}

@media screen and (min-width: 720px) and (max-width: 980px) {
  .product-description-img {
    --se-carousel-item-width: 245px;
  }
}

@media screen and (max-width: 719px) {
  .product-description-img {
    --se-carousel-item-width: 310px;
  }
}

@media screen and (max-width: 719px) {
  .end-overlay::before {
    content: none;
  }
}

@media screen and (max-width: 719px) {
  .end-overlay::before,
.end-overlay::after {
    width: 30px;
  }
}